import { AffiliateLink, Response } from '@/types';
import gql from 'graphql-tag';
import { ApiService } from '@/services';

export class AffiliateLinkService extends ApiService {
  public async mutateAffiliateLink(
    link: AffiliateLink
  ): Promise<AffiliateLink> {
    return link.id
      ? this.updateAffiliateLink(link)
      : this.createAffiliateLink(link);
  }

  public async createAffiliateLink(
    affiliateLink: AffiliateLink
  ): Promise<AffiliateLink> {
    const mutation = gql`
      mutation($affiliateLink: AffiliateLinkInput) {
        createAffiliateLink(affiliateLink: $affiliateLink) {
          id
          link_template
          affiliate_link_status
        }
      }
    `;
    return this.mutate(
      { mutation, variables: { affiliateLink } },
      'createAffiliateLink'
    );
  }

  public async updateAffiliateLink(
    affiliateLink: AffiliateLink
  ): Promise<AffiliateLink> {
    const mutation = gql`
      mutation($affiliateLink: AffiliateLinkInput) {
        updateAffiliateLink(affiliateLink: $affiliateLink) {
          id
          link_template
          affiliate_link_status
        }
      }
    `;
    return this.mutate(
      { mutation, variables: { affiliateLink } },
      'updateAffiliateLink'
    );
  }

  public async deleteAffiliateLink(id: number): Promise<Response> {
    const mutation = gql`
      mutation($id: ID!) {
        deleteAffiliateLink(id: $id) {
          id
          link_template
          affiliate_link_status
        }
      }
    `;
    return this.mutate({ mutation, variables: { id } }, 'deleteAffiliateLink');
  }
}

export const affiliateLinkSvc: AffiliateLinkService = new AffiliateLinkService();
